import { atom } from 'recoil';

// Open user-detail tabs (one per user the operator drills into) and the active tab index.
export const userTabListState = atom({
  key: "userTabListState",
  default: [],
});

export const userTabIndexState = atom({
  key: "userTabIndexState",
  default: 0,
});

// Toggled to force the user list to re-fetch (e.g. after a create/update).
export const userListRefreshState = atom({
  key: "userListRefreshState",
  default: true,
});
